<template lang="pug">
ul.nav.navbar-nav.selectedGroup(v-if="isConnected")
  li.dropdown(ref='dropdownElement')
    a.dropdown-toggle.clickable(data-toggle='dropdown')
      template(v-if='selectedGroops')
        vue-object-img(:object='firstSelectedGroop', v-if='selectedGroops.length == 1')
        i.fa.fa-group(v-else)
        span.text  {{ selectedGroopsString }}
      template(v-else)
        | {{$t("globals.loading")}}
    .closeBtn(v-if='!isAllGroopsSelected', @click='unselectGroup')
      i.fa.fa-times-circle
    .closeBtn(v-else, data-toggle='dropdown')
      i.fa.fa-caret-down
    .dropdown-menu.dropdown-menu-left.nopadding.group-list(ref='dropdown')
      ul.list
        li.dropdown-header {{$t("groups.explanation")}}
        li.active(@click='selectAllGroups')
          a.clickable 
            vue-object-img(:object='user')
            | {{$t('groups.allGroups')}}
        li(@click=' selectPersonalGroup')
          a.clickable
            vue-object-img(:object='user')
            | {{$t('groups.personalGroups')}}
        
        template(v-if='!groopsAreLoaded')
          li.dropdown-header {{$t("globals.loading")}}

        template(v-else)
          template(v-for='(typeAndGroups, key) in groupsAndType')
            li.dropdown-header(@click.stop='toggleShowInactiveGroupOfType(key)', role='button')
              template(v-if='typeAndGroups.inactive.length > 0')
                i.fa.fa-eye-slash.notRecentlyUsedBtn(v-if="groopTypeIsHidden(key)", :title="$t('groups.showUnusedGroups')")
                i.fa.fa-eye.notRecentlyUsedBtn(v-if='!groopTypeIsHidden(key)', :title="$t('groups.hideUnusedGroups')")
              //- i.fa(:class='key | groupTypeIcon')
              |  {{$t('groups.types.'+key)}}
              
            li(v-for='group in typeAndGroups.active', @click='selectGroup(group)')
              a.clickable(:title='group.name', data-tab='members') 
                input(type="checkbox", @click.stop="toggleSelection(group)", :checked='groopInSelection(group)', :class="{shown: !isAllGroopsSelected}")
                vue-object-img(:object='group')
                |  {{group.name}}
                i.fa.fa-cog.manageGroupBn(@click.stop="toGroupManagement(group)")
                i.fa.fa-users.manageMembersBn(@click.stop="toMembers(group)")
            template(v-if='!groopTypeIsHidden(key)')
              li(v-for='group in typeAndGroups.inactive', @click='selectGroup(group)')
                a.clickable(:title='group.name')  
                  vue-object-img(:object='group')
                  input(type="checkbox", @click.stop="toggleSelection(group)", :checked='groopInSelection(group)', :class="{shown: !isAllGroopsSelected}")
                  |  {{group.name}}
                  i.fa.fa-cog.manageGroupBn(@click="toGroupManagement(group)")
                  i.fa.fa-users.manageMembersBn(@click="toMembers(group)")
      ul.footer(v-if='groopsAreLoaded')
        li(@click='createGroup()')
          a
            i.fa.fa-plus
            |  {{$t("groups.createAGroup")}}
        li(@click='openMembers')
          a
            i.fa.fa-user-plus
            |  {{$t("groups.createMembersModal.title")}}
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'

import _ from 'lodash'
import $ from 'jquery'

import VueObjectImg from '@/components/shared/VueObjectImg'

import 'bootstrap-tour/build/css/bootstrap-tour.css'
// import Tour from 'bootstrap-tour/build/js/bootstrap-tour'

// import HelpTip from '@/tools/helptip/helptip'
import modalsBus from '@/components/shared/ModalsBus'

// HelpTip.defaults({
//   buttons: {
//     stop: "J'ai compris",
//     next: 'Suivant'
//   },
//   changeBtn: ($button, button) => {
//     $button.css({'margin-right': 40})
//   },
//   storage: {
//     getItem () {},
//     setItem () {}
//   }
// })

export default {
  data () {
    return {
      typesToShowInactiveGroups: [],
      showSelectAGroupForMember: false
    }
  },
  components: {
    VueObjectImg
  },
  mounted () {
    // this.installDropdownHint()
    this.showDropdownHint()
  },
  computed: {
    ...mapGetters('user', [
      'isConnected',
      'user'
    ]),
    ...mapGetters('groops', [
      'groops',
      'selectedGroops',
      'isAllGroopsSelected',
      'selectedGroopsString',
      'groopsAreLoaded',
      'firstSelectedGroop'
    ]),
    groupsAndType () {
      let groupsAndType = {}
      let sixMonth = moment().subtract(6, 'month').unix()

      this.groops.forEach((group) => {
        if (group.id === -2) {
          return
        }
        groupsAndType[group.type] = groupsAndType[group.type] || {active: [], inactive: []}
        if (group.lastNotificationTime < sixMonth) {
          groupsAndType[group.type].inactive.push(group)
        } else {
          groupsAndType[group.type].active.push(group)
        }
      })
      return groupsAndType
    }
  },
  methods: {
    unselectGroup () {
      this.selectAllGroups()
    },
    selectGroup (groop) {
      this.$store.dispatch('groops/select', [groop])
    },
    selectPersonalGroup () {
      this.$store.dispatch('groops/selectPersonalGroop')
    },
    selectAllGroups () {
      this.$store.dispatch('groops/selectAllGroops')
    },
    groopTypeIsHidden (type) {
      return this.typesToShowInactiveGroups.indexOf(type) === -1
    },
    toggleShowInactiveGroupOfType (type) {
      if (this.groopTypeIsHidden(type)) {
        this.typesToShowInactiveGroups.push(type)
      } else {
        this.typesToShowInactiveGroups = _.filter(this.typesToShowInactiveGroups, (t) => t !== type)
      }
    },
    groopInSelection (groop) {
      return this.$store.getters['groops/groopInSelection'](groop)
    },
    toggleSelection (groop) {
      if (!this.groopInSelection(groop)) {
        this.$store.dispatch('groops/addInSelection', groop)
      } else {
        this.$store.dispatch('groops/removeFromSelection', groop)
      }
    },
    createGroup () {
      modalsBus.open(modalsBus.modals.CREATE_GROUP)
    },
    async openMembers () {
      if (!this.firstSelectedGroop) {
        modalsBus.open(modalsBus.modals.SELECT_A_GROUP, {
          helpText: 'modals.selectAGroup.helpTextFromContact',
          onSelectGroup: async (group) => {
            modalsBus.closeAll()
            await this.$router.push('/members/' + group.id)
            modalsBus.open(modalsBus.modals.CREATE_MEMBERS)
          }})
      } else {
        await this.$router.push('/members/' + this.firstSelectedGroop.id)
        modalsBus.open(modalsBus.modals.CREATE_MEMBERS)
      }
    },
    toMembers (groop) {
      this.$router.push('/members/' + groop.id)
      $(this.$refs.dropdown).dropdown('toggle')
    },
    toGroupManagement (groop) {
      this.$router.push('/groupManagement/' + groop.id)
      $(this.$refs.dropdown).dropdown('toggle')
    },
    installDropdownHint () {
      // setTimeout(() => {
      //   (function () {
      //     let tour = new Tour({
      //       storage: false,
      //       template: "<div class='popover tour'>" +
      //                   "<div class='arrow'></div>" +
      //                   "<h3 class='popover-title'></h3>" +
      //                   "<div class='popover-content'></div>" +
      //                   "<div class='popover-navigation'>" +
      //                   "<button class='btn btn-default btn-xs' data-role='prev'>« Préc</button>" +
      //                   "<span data-role='separator'>&nbsp;</span>" +
      //                   "<button class='btn btn-default btn-xs' data-role='next'>Suiv »</button>" +
      //                   "<button class='btn btn-default btn-xs' data-role='end'>J'ai compris</button>" +
      //                 '</div>',
      //       steps: [
      //         {
      //           title: 'Bienvenue sur GroopUs.com !',
      //           content: 'Laissez-vous guider pour découvrir la richesse de cet outil !',
      //           orphan: true,
      //           backdrop: true
      //         },
      //         {
      //           element: 'ul.nav.navbar-nav.selectedGroup .dropdown',
      //           title: 'Vos groupes',
      //           content: 'Toutes les pages sont filtrées en fonction des groupes choisis. <br>Cliquez ici pour sélectionner un ou plusieurs groupes. <br>La page filtrera alors les informations en fonction de ces groupes.',
      //           placement: 'bottom',
      //           reflex: true
      //         },
      //         {
      //           element: '.mainSearchForm',
      //           title: 'Recherche ce que vous voulez',
      //           content: 'Entrez un texte ici et les éléments pertinents apparaîtront',
      //           placement: 'bottom',
      //           reflex: true
      //         }
      //       ]
      //     })
      //     tour.init()
      //     tour.start()
      //   })()
      // }, 1000)
      // setTimeout(() => {
      //   $(this.$refs.dropdownElement).on('shown.bs.dropdown', () => {
      //     if ($('.notRecentlyUsedBtn', this.$el).length > 0) {
      //       // keep dropdown open
      //       $(this.$refs.dropdownElement).on('hidden.bs.dropdown', () => {
      //         tour.end()
      //       })
      //       let tour = new Tour({
      //         storage: false,
      //         template: "<div class='popover tour'>" +
      //                     "<div class='arrow'></div>" +
      //                     "<h3 class='popover-title'></h3>" +
      //                     "<div class='popover-content'></div>" +
      //                     "<div class='popover-navigation'>" +
      //                     "<button class='btn btn-default btn-xs' data-role='end'>J'ai compris</button>" +
      //                   '</div>',
      //         onEnd: () => {
      //           $(this.$refs.dropdownElement).off('hidden.bs.dropdown')
      //         },
      //         onNext: () => {
      //           setTimeout(() => {
      //             $(this.$refs.dropdownElement).off('hidden.bs.dropdown')
      //           }, 100)
      //         },
      //         steps: [
      //           {
      //             element: '.notRecentlyUsedBtn:first',
      //             title: 'Groupes cachés',
      //             content: 'Vos groupes non utilisés depuis au moins 6 mois sont automatiquement cachés.<br>Cliquez ici pour les retrouver.',
      //             reflex: true
      //           }
      //         ]
      //       })
      //       tour.init()
      //       tour.start()
      //     }
      //   })
      // }, 1000)
    },
    showDropdownHint () {
      // let helpTip = new HelpTip({
      //   el: '.nav.navbar-nav.selectedGroup .dropdown',
      //   contents: 'Toutes les pages sont filtrées en fonction des groupes choisis. <br>Cliquez ici pour sélectionner un ou plusieurs groupes. <br>La page filtrera alors les informations en fonction de ces groupes. ',
      //   delay: 0,
      //   name: 'groups'
      // })
      // helpTip.show()
      // new HelpTip({
      //   el: '.mainSearchForm input',
      //   contents: 'Entrez un texte ici et les éléments pertinents apparaîtront',
      //   name: 'mainSearchForm'
      // }).show()

      // $(this.$refs.dropdownElement).on('shown.bs.dropdown', () => {
      //   new HelpTip({
      //     onNext: 'stop',
      //     el: $('.group-list', this.$refs.dropdownElement),
      //     duration: 100,
      //     allowElementEvent: false,
      //     contents: 'Tous vos groupes...',
      //     name: 'groupList'
      //   }).show()
      //   if ($('.notRecentlyUsedBtn', this.$el).length > 0) {
      //     new HelpTip({
      //       el: $('.notRecentlyUsedBtn:first', this.$el),
      //       margin: 50,
      //       name: 'hiddenGroups',
      //       radius: '50%',
      //       duration: 100,
      //       contents: 'Vos groupes non utilisés depuis au moins 6 mois sont automatiquement cachés.<br>Cliquez ici pour les retrouver.'
      //     }).show()
      //   }
      // })
    }
  },
  watch: {
    groopsAreLoaded () {
      if (this.groopsAreLoaded) {
        this.$nextTick(() => {
          this.showDropdownHint()
        })
      }
    }
  }
}
</script>
<style lang="sass">
.navbar-nav.selectedGroup a.dropdown-toggle .profileImage
  height: 35px
  width: 35px
  line-height: 35px
  position: absolute
  top: 7px
  & ~ .text
    padding-left: 40px
// .navbar-nav.selectedGroup a:hover input[type=checkbox]
//   display: block
</style>



// WEBPACK FOOTER //
// HeaderGroupSelection.vue?70886b80